import { OMY_SETTING, OmyConst } from "./OmyConst";
import GameCache from "./tools/GameCache";
import Factory from "./tools/Factory";
import Destroyer from "./tools/Destroyer";
import Localization from "./managers/Localization";
import KeyManager from "./managers/KeyManager";
import OSound from "./managers/OSound";
import AssetsManager from "./managers/AssetsManager";
import ViewManager from "./managers/ViewManager";
import NavigateBtns from "./managers/NavigateBtns";
import OMouse from "./tools/OMouse";
import ScaleManager from "./managers/ScaleManager";
import OS from "./utils/OS";
import Browser from "./utils/Browser";
import { version } from "../../package.json";

import md5 from "md5";

import _Random from "yy-random";
import { Ease } from "../lib/ease.js";
import { Keyboard } from "../lib/pixi.js-keyboard";
import GameSizeManager from "./managers/GameSizeManager";
import OMap from "./utils/OMap";
import OMath from "./utils/OMath";

let _assetsURL = "";
let _isDesktop = true;
let _isScreenPortrait = false;
let _dx = 0;
let _dy = 0;
let _scale = 1;
/** @type {number} */
let _t = 0;
let _fps = 0;

/** @type {OmyGame} */
let _game = null;

let parDecoded;
let _isLocal = false;
let _isOmy = false;
let _debugMode = false;
let _allowConsole = false;
let _showFPS = false;
let saidHello = false;
let _language = "eng";
let _offWebpSupport = false;
let _isWebGL = true;
const _version = version;
let _URLCacheTournament = "";

/** @type {PIXI.utils.EventEmitter} */
let _onGameSecUpdate = new OmyConst.Emit();

/** @type {Factory} */
let _add;
/** @type {Destroyer} */
let _remove;
/** @type {GameCache} */
let _cache;
/** @type {Localization} */
let _loc;
/** @type {KeyManager} */
let _keys;
/** @type {OSound} */
let _sound;
/** @type {AssetsManager} */
let _assets;
/** @type {ViewManager} */
let _viewManager;
/** @type {NavigateBtns} */
let _navigateBtn;
/** @type {OMouse} */
let _mouse;
/** @type {ScaleManager} */
let _scaleManager;
/** @type {GameSizeManager} */
let _gameSizeManger;
/** @type {OS} */
let _OS;
/** @type {Browser} */
let _browser;

/** @type {OMap} */
let _revoltParticle = new OMap();
let _revoltListNames = [];

export default class Omy {
    static init() {
        Omy.sayHello();

        _fps = 60;
        _game.ticker.add(this._update, this);

        _isWebGL = _game.renderer instanceof PIXI.Renderer;

        _OS = new OS();
        _browser = new Browser(_OS);

        _mouse = new OMouse();
        _assets = new AssetsManager();
        _keys = new KeyManager();
        _cache = new GameCache(_game.stage);
        _add = new Factory(_cache);
        _remove = new Destroyer(_cache);
        _sound = new OSound();
        _navigateBtn = new NavigateBtns();

        _scaleManager = new ScaleManager(_game);
        _gameSizeManger = new GameSizeManager();

        _loc = new Localization();
        _viewManager = new ViewManager();
        _game.stage.addChild(_viewManager);
        _game.ticker.add(this._updateRevolt);
    }

    /**
     * @param {String}revoltName
     * @param {Object}json
     */
    static initRevolt(revoltName, json) {
        if (_revoltParticle.has(revoltName)) return;
        const rev = new revolt.FX();
        _revoltParticle.set(revoltName, rev);
        rev.initBundle(json);
        _revoltListNames = _revoltParticle.names();
    }

    static _updateRevolt() {
        for (let i = 0; i < _revoltListNames.length; i++) {
            _revoltParticle.get(_revoltListNames[i]).update();
        }
    }

    /**
     * @param {String}name
     * @returns {revolt.FX}
     */
    static revolt(name) {
        for (let i = 0; i < _revoltListNames.length; i++) {
            /** @type {revolt.FX} */
            let revoltFX = _revoltParticle.get(_revoltListNames[i]);
            for (let effectName in revoltFX._nameMaps.emitters) {
                if (effectName === name) return revoltFX;
            }
            for (let effectName in revoltFX._nameMaps.effectSequences) {
                if (effectName === name) return revoltFX;
            }
        }
        return null;
    }

    static addUpdater(func, context) {
        _game.ticker.add(func, context);
    }

    static removeUpdater(func, context) {
        _game.ticker.remove(func, context);
    }

    static addSecUpdater(func, context) {
        _onGameSecUpdate.on("dispatch", func, context);
    }

    static removeSecUpdater(func, context) {
        _onGameSecUpdate.removeListener("dispatch", func, context);
    }

    static _update() {
        _viewManager.update();
        if (--_t < 1) {
            _onGameSecUpdate.emit("dispatch");
            _t = _fps;
        }
    }

    static updateGameSize(container, dx, dy, isScreenPortrait) {
        _dx = dx;
        _dy = dy;
        _gameSizeManger.updateGameSize(container, dx, dy, isScreenPortrait);
    }

    static updateGameSizeForce(container) {
        _gameSizeManger.updateGameSize(container, _dx, _dy, _isScreenPortrait);
    }

    /**     * @public     */
    static checkURL() {
        let adr = document.domain;
        parDecoded = decodeURIComponent(location.search);

        function getURLParameter(name) {
            return (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(parDecoded) || ["", ""])[1].replace(/\+/g, "%20") || null;
        }

        _debugMode = getURLParameter("editMode") === "true" || _debugMode;
        _allowConsole = getURLParameter("allowConsole") === "true" || _allowConsole;
        _showFPS = getURLParameter("showFPS") === "true" || _showFPS;
        _offWebpSupport = getURLParameter("offWebpSupport") === "true" || _offWebpSupport;

        _isLocal = adr.indexOf("localhost") !== -1;
        _isOmy = adr.indexOf("omygames") !== -1;

        if (_debugMode) {
            _allowConsole = true;
            _showFPS = true;
        }
    }

    static skipHello() {
        saidHello = true;
    }

    static sayHello() {
        if (saidHello) {
            return;
        }

        if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
            let args = ["%c %c %c OmyPixiJS " + _version + " --- " + " http://omygames.com/  %c  \n", "background: #478c13; padding:5px 0;", "background: #478c13; padding:5px 0;", "color: #478c13; background: #030307; padding:5px 0;", "background: #478c13; padding:5px 0;"];

            window.console.log.apply(console, args);
        } else if (window.console) {
            window.console.log("OmyPixiJS " + _version + " --- " + " - http://omygames.com/");
        }

        saidHello = true;
    }

    static log(...rest) {
        if (_allowConsole)
            console.log.apply(console, rest);
    }

    static warn(...rest) {
        if (_allowConsole)
            console.warn.apply(console, rest);
    }

    static info(...rest) {
        if (_allowConsole)
            console.info.apply(console, rest);
    }

    static group(...rest) {
        if (_allowConsole)
            console.group.apply(console, rest);
    }

    static groupCollapsed(...rest) {
        if (_allowConsole)
            console.groupCollapsed.apply(console, rest);
    }

    static groupEnd() {
        if (_allowConsole)
            console.groupEnd();
    }

    static error(...rest) {
        console.error.apply(console, rest);
    }

    static set assetsURL(value) {
        _assetsURL = value;
    }

    static get assetsURL() {
        return _assetsURL;
    }

    static set isDesktop(value) {
        _isDesktop = value;
    }

    static get isDesktop() {
        return _isDesktop;
    }

    static set scale(value) {
        _scale = value;
    }

    static get scale() {
        return _scale;
    }

    static set game(value) {
        _game = value;
    }

    /**
     * @returns {OmyGame}
     */
    static get game() {
        return _game;
    }

    static get stage() {
        return _game.stage;
    }

    static get isLocal() {
        return _isLocal;
    }

    static get isOmy() {
        return _isOmy;
    }

    static get allowConsole() {
        return _allowConsole;
    }

    static get showFPS() {
        return _showFPS;
    }

    static set showFPS(value) {
        _showFPS = value;
        if (_game && _game.stats) {
            if (value) {
                document.body.appendChild(_game.stats.dom);
            } else {
                document.body.removeChild(_game.stats.dom);
            }
        }
    }

    static get URLCache() {
        return (OMY_SETTING.NO_CACHE_ASSETS_ON_LOAD) ? "" : "?" + String(md5(OmyConst.vers.version));
    }

    static set URLCacheTournament(value) {
        _URLCacheTournament = value;
    }

    /**
     * @return {string}
     */
    static get URLCacheTournament() {
        return "?" + (_URLCacheTournament || String(md5(OMath.uniqueID())));
    }

    /**     * @returns {Factory}     */
    static get add() {
        return _add;
    }

    /**     * @returns {Destroyer}     */
    static get remove() {
        return _remove;
    }

    static get cache() {
        return _cache;
    }

    /**     * @returns {Localization}     */
    static get loc() {
        return _loc;
    }

    /**     * @returns {KeyManager}     */
    static get keys() {
        return _keys;
    }

    static get fps() {
        return _fps;
    }

    /**     * @returns {OSound}     */
    static get sound() {
        return _sound;
    }

    /**     * @returns {AssetsManager}     */
    static get assets() {
        return _assets;
    }

    /**     * @returns {ViewManager}     */
    static get viewManager() {
        return _viewManager;
    }

    /**     * @returns {NavigateBtns}     */
    static get navigateBtn() {
        return _navigateBtn;
    }

    static set language(value) {
        _language = value;
    }

    static get language() {
        return _language;
    }

    /**     * @returns {OMouse}     */
    static get mouse() {
        return _mouse;
    }

    static get debugMode() {
        return _debugMode;
    }

    static get scaleManager() {
        return _scaleManager;
    }

    static get OS() {
        return _OS;
    }

    static get browser() {
        return _browser;
    }

    static get offWebpSupport() {
        return _offWebpSupport;
    }

    static get isWebGL() {
        return _isWebGL;
    }

    /**
     * https://davidfig.github.io/pixi-ease/jsdoc/Ease.html#ease
     * @returns {{AddOptions: AddOptions, EaseOptions: EaseOptions, ease: Ease, Easing: Easing, Ease: Ease, EaseParams: EaseParams}}
     * @constructor
     */
    static get Ease() {
        return Ease.ease;
    }

    static get Random() {
        return _Random;
    }

    static get revoltParticle() {
        throw new Error("old use. For init bundle use assetsManager.");
        return null;
    }

    static get keyboardManager() {
        return Keyboard.keyboard.events;
    }

    static get version() {
        return _version;
    }

    static get isScreenPortrait() {
        return _isScreenPortrait;
    }

    static set isScreenPortrait(value) {
        _isScreenPortrait = value;
    }

    /**
     * @returns {PIXI.Renderer}
     */
    static get renderer() {
        return _game.renderer;
    }

    /**
     * @returns {PIXI.Loader}
     */
    static get loader() {
        return _game.loader;
    }

    /**
     * @returns {Object}
     */
    static get resources() {
        return _game.loader.resources;
    }

    static get dx() {
        return _dx;
    }

    static get dy() {
        return _dy;
    }
}

window.Clipboard = (function(window, document, navigator) {
    var textArea,
        copy;

    function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
    }

    function createTextArea(text) {
        textArea = document.createElement("textArea");
        textArea.value = text;
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range,
            selection;

        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        } else {
            textArea.select();
        }
    }

    function copyToClipboard() {
        document.execCommand("copy");
        document.body.removeChild(textArea);
    }

    copy = function(text) {
        createTextArea(text);
        selectText();
        copyToClipboard();
    };

    return {
        copy: copy
    };
})(window, document, navigator);

Omy.WIDTH = 0;
Omy.HEIGHT = 0;
